export default __webpack_public_path__ + "static/media/sunset-plane-mobile.44c3ae5b.png";